import { Button } from '@/ui/Button/Button';
import { Flex } from '@/ui/Flex/Flex';
import { Modal } from '@/ui/Modal/Modal';
import { T } from '@/ui/Text/Text';
import React from 'react';
import { useIntl } from 'react-intl';

type EnableLogicEditorModalProps = {
  isWarningModalOpen: boolean;
  setIsWarningModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading: boolean;
  isSaving: boolean;
  savingScript: boolean;
  handleSave: () => Promise<any> | Error;
  refetchScript: () => void;
  refetchUnit: () => void;
  setIsEditingCode: React.Dispatch<React.SetStateAction<boolean>>;
};
function EnableLogicEditorModal({
  isWarningModalOpen,
  setIsWarningModalOpen,
  isLoading,
  isSaving,
  savingScript,
  handleSave,
  refetchScript,
  refetchUnit,
  setIsEditingCode,
}: EnableLogicEditorModalProps) {
  const intl = useIntl();
  return isWarningModalOpen ? (
    <Modal
      onClose={() => setIsWarningModalOpen(false)}
      title={`⚠️ ${intl.formatMessage({
        defaultMessage: 'Attention',
        id: '71PFKb',
      })}`}
      footer={
        <Flex gap={16} padding={16} justify="flex-end" grow>
          <Button
            size="medium"
            loading={isLoading || isSaving || savingScript}
            onClick={() => {
              setIsWarningModalOpen(false);
              setIsEditingCode(true);
            }}
          >
            {intl.formatMessage({
              defaultMessage: 'Cancel',
              id: '47FYwb',
            })}
          </Button>
          <Button
            size="medium"
            mode="danger"
            loading={isLoading || isSaving || savingScript}
            onClick={async () => {
              // else just save normally and refetch the script to show the updated code in codeview
              await handleSave();
              await refetchScript();
              // also refetch the unit incase logicEditorEnabled changed
              await refetchUnit();
              setIsWarningModalOpen(false);
            }}
          >
            {intl.formatMessage({
              defaultMessage: 'Enable',
              id: 'TqSTI0',
            })}
          </Button>
        </Flex>
      }
    >
      <T>
        {intl.formatMessage({
          defaultMessage:
            'You are about to enable the Logic Editor, and leave Developer Mode. This will overwrite any code changes you or your admin made in Developer Mode!',
          id: 'iadPHV',
        })}
      </T>
    </Modal>
  ) : null;
}

export default EnableLogicEditorModal;
